import { Suspense, lazy } from 'react'

import type { RouteProps } from 'react-router-dom'

import { LoadingScreen } from 'views/loading'

const HomeView = lazy(() => import('./views/home'))

export enum ROUTE {
  HOME = '/',
}

export const routes: Array<
  RouteProps & {
    i18nKey?: string
    nested?: RouteProps
  }
> = [
  {
    path: ROUTE.HOME,
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <HomeView />
      </Suspense>
    ),
  },
]
